import type { Validate } from 'react-hook-form';

export function combineValidators<TFieldValue = string>(
  ...validators: Validate<TFieldValue, unknown>[]
): Validate<TFieldValue, unknown> {
  return function combinedValidator(value: TFieldValue, form) {
    for (const validator of validators) {
      const result = validator(value, form);

      if (result === false || typeof result === 'string') {
        return result;
      }
    }

    return undefined;
  };
}
